<label for="{{label}}" *ngIf="isFloating"
  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{label}}</label>
<div class="relative">
  <button (click)="clickDropdown()" id="{{label}}"
    class="flex items-center justify-between input__floating peer bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-600 shadow-blue"
    type="button">{{selectedOption.displayText || initialPlaceholder }}
    <img src="assets/images/down-arrow.svg" class="w-3 h-3" alt="">
  </button>
  <!-- Dropdown menu -->
  <div *ngIf="toggleListing"
    class="absolute h-52 w-full overflow-auto select__dropdown bg-gray-50 border border-gray-300 px-2.5 z-10">
    <input type="text" placeholder={{placeholder}}
      class="my-2 py-2 px-4 font-regular w-full placeholder:text-placeholder shadow-inner input-calc-country
      bg-gray-50  border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 "
      [(ngModel)]="searchKeyword" (input)="searchCountries($event)">
    <ul class="m-2 mt-0 text-sm">
      <li *ngFor="let item of filteredItems" class=" hover:bg-gray-300" (click)="onSelectChange(item.value)">
        <a  class="select__dropdown--menu">{{item.displayText}}</a>
      </li>
    </ul>
  </div>
</div>